<template>
  <div class="page t-container">
    <span class="page-subheading">HOME</span>
    <div class="page-heading" role="heading">
      <h1 class="page-heading__header">
        Dashboard
      </h1>
      <div class="t-mt-4 md:t-mt-0">
        <button
          @click="onNewBookingClick"
          class="t-align-right t-bg-dodger-blue t-px-8 t-py-3"
        >
          <span class="t-text-base t-font-bold t-text-white">
            <span class="t-text-sm">+</span>
            New Booking
          </span>
        </button>
      </div>
    </div>

    <section
      class="t-mt-12 t-flex t-flex-col t-space-y-8 lg:t-space-y-0 lg:t-flex-row"
      role="main"
    >
      <div class="t-flex t-flex-col t-space-y-8 lg:t-w-13/20 lg:t-mr-8">
        <section
          class="dashboard-content t-flex-col t-rounded-md t-p-4 t-bg-white"
        >
          <div style="border-bottom: 2px solid #EEEEEE;" class="t-pt-2 t-pb-4">
            <h3 class="t-text-xl t-font-bold">
              Outgoing Freight
            </h3>
          </div>

          <dashboard-freight-table
            :freight-bookings="outgoingBookings"
            :watchlist-freight-bookings="watchlistOutgoingBookings"
            :freight-type="'OUTGOING'"
            @outgoingBookingSelected="booking => onBookingSelected(booking)"
          />
        </section>

        <section
          class="dashboard-content t-flex-col t-rounded-md t-shadow-lg t-p-4 t-bg-white"
        >
          <div style="border-bottom: 2px solid #EEEEEE;" class="t-pt-2 t-pb-4">
            <h3 class="t-text-xl t-font-bold">
              Incoming Freight
            </h3>
          </div>

          <dashboard-freight-table
            :freight-bookings="incomingBookings"
            :watchlist-freight-bookings="watchlistIncomingBookings"
            :freight-type="'INCOMING'"
            @incomingBookingSelected="booking => onBookingSelected(booking)"
          />
        </section>

        <section
          class="dashboard-content t-flex-col t-rounded-md t-p-4 t-bg-white"
        >
          <div style="border-bottom: 2px solid #EEEEEE;" class="t-pt-2 t-pb-4">
            <h3 class="t-text-xl t-font-bold">
              Trackers
            </h3>
          </div>

          <tracker-info
            :trackers="trackers"
            :is-loaded="isLoaded"
            :error-msg="errorMsg"
          />
        </section>
      </div>
      <div class="t-flex lg:t-flex-grow">
        <tracking-section
          :selected-booking="selectedBooking"
          class="dashboard-content t-w-full"
        />
      </div>
    </section>
  </div>
</template>

<script>
import TrackingSection from "./components/sections/DashboardTrackingSection";
import DashboardFreightTable from "./components/tables/DashboardFreightTable";
import TrackerInfo from "./components/sections/TrackerInfo";

export default {
  name: "DashboardPage",
  description: "",
  components: {
    TrackingSection,
    DashboardFreightTable,
    TrackerInfo
  },
  data() {
    return {
      selectedBooking: null,
      trackers: null,
      isLoaded: false,
      errorMsg: null
    };
  },
  computed: {
    outgoingBookings() {
      return this.$store.getters.getOutgoingBookings;
    },
    watchlistOutgoingBookings() {
      return this.$store.getters.getWatchlistOutgoingBookings;
    },
    incomingBookings() {
      return this.$store.getters.getIncomingBookings;
    },
    watchlistIncomingBookings() {
      return this.$store.getters.getWatchlistIncomingBookings;
    }
  },
  mounted() {
    this.getTrackersCount();
  },
  created() {
    this.$store.dispatch("loadBookings");
    this.$store.dispatch("loadDefaultPickupLocation");
    this.$store.dispatch("loadAssets");
  },
  methods: {
    onNewBookingClick() {
      console.log("here");
      window.location.href = "/send-freight/new";
    },
    onBookingSelected(booking) {
      this.selectedBooking = booking;
    },
    getTrackersCount() {
      this.isLoaded = false;
      axios
        .get("/send-freight/tracker/unlink/onsite/count")
        .then(response => {
          this.trackers = response.data.trackers_count;
          this.isLoaded = true;
        })
        .catch(() => {
          Event.$emit("serverError");
          this.isLoaded = false;
          this.errorMsg = "No Trackers Set Yet";
        });
    }
  }
};
</script>

<style scoped></style>
